// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
{
    /* CONFIG IMPORT*/
}

import React, { useState, useEffect } from "react";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import { NavigationContainer } from "@react-navigation/native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { createStackNavigator } from "@react-navigation/stack";
import {
    formatDate,
    getTranslation,
    renderRightComponent,
} from "../../utils/utils";
import {
    fetchActiveTransferGroup,
    fetchHandleMaterials,
} from "../../axios/axiosConfig";
{
    /* END CONFIG IMPORT */
}

{
    /* SCREENS IMPORT*/
}
import MovementScreen from "../../screens/Farmer/MovementScreen";
import HandlingDigestateScreen from "../../screens/Farmer/HandlingDigestateScreen";
import TrasportRoutesScreen from "../../screens/Carrier/MovementScreen2";
import DataScreen from "../../screens/Farmer/DataScreen";
import ProfileScreenFarmer from "../../screens/Farmer/ProfileScreenFarmer";
import ProfileScreenDriver from "../../screens/Carrier/ProfileScreenDriver";
import LoginScreen from "../../screens/Common/LoginScreen";
import Header from "../Header";
import AsyncStorage from "@react-native-async-storage/async-storage";
import SharedDepositStatistics from "../../screens/SharedDepositManager/SharedDepositStatistics";
import RequestsScreen from "../../screens/Carrier/RequestsScreen";
import HandlingDigestateScreen2 from "../../screens/SharedDepositManager/HandlingDigestateScreen";

{
    /* END SCREENS IMPORT */
}

{
    /* MAIN APP NAVIGATOR */
}
const AppNavigator = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const [userData, setUserData] = useState({
        firstName: "Unknown",
        lastName: "Unknown",
        landingView: "Farmer",
        hasDigestate: true,
    });

    const clearUserData = async () => {
        try {
            await AsyncStorage.removeItem("userData");
            setIsLoggedIn(false);
            setUserData({
                firstName: "Unknown",
                lastName: "Unknown",
                landingView: "Farmer",
            });
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        const loadUserData = async () => {
            try {
                const userDataFromStorage = await AsyncStorage.getItem("userData");
                if (userDataFromStorage) {
                    const parsedUserData = JSON.parse(userDataFromStorage);
                    setUserData(parsedUserData);
                    setIsLoggedIn(true);
                }
            } catch (error) {
                console.error(error);
            }
        };

        let inactivityTimeout = setTimeout(clearUserData, 24 * 60 * 60 * 1000);

        const clearAndResetInactivityTimeout = () => {
            clearTimeout(inactivityTimeout);
            inactivityTimeout = setTimeout(clearUserData, 24 * 60 * 60 * 1000);
        };

        loadUserData();

        document.addEventListener("click", clearAndResetInactivityTimeout);
        document.addEventListener("keydown", clearAndResetInactivityTimeout);

        return () => {
            document.removeEventListener("click", clearAndResetInactivityTimeout);
            document.removeEventListener("keydown", clearAndResetInactivityTimeout);
        };
    }, []);

    async function handleLogin(firstName, lastName, landingView) {
        try {
            let hasDigestate = true;
            if (landingView === "Farmer" || landingView === "SharedDepositManager") {
                const response = await fetchHandleMaterials(false);
                if (response.status === 200) {
                    hasDigestate = response.data.includes("DigestatoLiquido");
                }
            }

            const userDataToSave = JSON.stringify({
                firstName,
                lastName,
                landingView,
                hasDigestate,
            });

            await AsyncStorage.setItem("userData", userDataToSave);

            setUserData({
                firstName,
                lastName,
                landingView,
                hasDigestate,
            });
            setIsLoggedIn(true);
        } catch (error) {
            console.error(error);
        }
    }
    return (
        <NavigationContainer>
            {isLoggedIn ? (
                <MainNavigator
                    language={language}
                    user={userData}
                    loginStatus={setIsLoggedIn}
                />
            ) : (
                <AuthNavigator onLogin={handleLogin} language={language} />
            )}
        </NavigationContainer>
    );
};

{
    /* END MAIN APP NAVIGATOR */
}

const language = navigator.language;

{
    /*DECLARE STACK NAVIGATOR */
}
const AuthStack = createStackNavigator();
const FarmerStack = createBottomTabNavigator();
const CarrierStack = createBottomTabNavigator();
const SharedDepositManagerStack = createBottomTabNavigator();

const AuthNavigator = ({ onLogin, language }) => (
    <AuthStack.Navigator>
        <AuthStack.Screen name="Login" options={{ headerShown: false }}>
            {(props) => (
                <LoginScreen
                    {...props}
                    onLogin={onLogin}
                    language={language}
                    getTranslation={getTranslation}
                />
            )}
        </AuthStack.Screen>
    </AuthStack.Navigator>
);

const SharedDepositManagerNavigator = ({ user, titles, loginStatus }) => {
    const [userData, setUserData] = useState({});

    const MovementComponentWrapperSh = (props) => {
        return (
            <MovementScreen
                {...props}
                user={user}
                getTranslation={getTranslation}
                formatDate={formatDate}
                sharedDepositManager={true}
            />
        );
    };

    const DigestateComponentWrapperSh = (props) => {
        return (
            <HandlingDigestateScreen
                {...props}
                user={user}
                getTranslation={getTranslation}
                formatDate={formatDate}
                language={language}
            />
        );
    };

    const StatisticsComponentWrapperSh = (props) => {
        return (
            <SharedDepositStatistics
                {...props}
                getTranslation={getTranslation}
                user={user}
                formatDate={formatDate}
            />
        );
    };

    const ProfileComponentWrapperSh = (props) => {
        return (
            <ProfileScreenFarmer
                {...props}
                getTranslation={getTranslation}
                user={user}
                formatDate={formatDate}
            />
        );
    };

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const storedUserData = await AsyncStorage.getItem("userData");
                if (storedUserData) {
                    setUserData(JSON.parse(storedUserData));
                    console.log(userData);
                }
            } catch (error) {
                console.error(error);
            }
        };

        fetchUserData();
    }, []);


    return (
        <SharedDepositManagerStack.Navigator
            screenOptions={({ route }) => ({
                tabBarIcon: ({ color, size }) => {
                    let iconName;
                    switch (route.name) {
                        case titles.first:
                            iconName = "home";
                            break;
                        case titles.second:
                            iconName = "grass";
                            break;
                        case titles.third:
                            iconName = "chart-bar";
                            break;
                        case titles.fourth:
                            iconName = "account";
                            break;
                        default:
                            iconName = "truck";
                            break;
                    }
                    return (
                        <MaterialCommunityIcons name={iconName} color={color} size={size} />
                    );
                },
                tabBarActiveTintColor: "green",
                tabBarInactiveTintColor: "gray",
            })}
        >
            <SharedDepositManagerStack.Screen
                name={titles.first}
                component={MovementComponentWrapperSh}
                options={{
                    header: () => (
                        <Header
                            title={titles.first}
                            icon="home"
                            user={user}
                            getTranslation={getTranslation}
                            loginStatus={loginStatus}
                        />
                    ),
                    unmountOnBlur: true,
                }}
            />

            {userData.hasDigestate && (
                <SharedDepositManagerStack.Screen
                    name={titles.second}
                    component={DigestateComponentWrapperSh}
                    options={{
                        header: () => (
                            <Header
                                title={titles.second}
                                icon="grass"
                                user={user}
                                getTranslation={getTranslation}
                                loginStatus={loginStatus}
                            />
                        ),
                    }}
                />
            )}

            <SharedDepositManagerStack.Screen
                name={titles.third}
                component={StatisticsComponentWrapperSh}
                options={{
                    header: () => (
                        <Header
                            title={titles.third}
                            icon="chart-bar"
                            user={user}
                            getTranslation={getTranslation}
                            loginStatus={loginStatus}
                        />
                    ),
                }}
            />

            <SharedDepositManagerStack.Screen
                name={titles.fourth}
                component={ProfileComponentWrapperSh}
                options={{
                    header: () => (
                        <Header
                            title={titles.fourth}
                            icon="account"
                            user={user}
                            getTranslation={getTranslation}
                            loginStatus={loginStatus}
                        />
                    ),
                }}
            />
        </SharedDepositManagerStack.Navigator>
    );
};

const FarmerNavigator = ({ user, titles, loginStatus }) => {
    const MovementComponentWrapper = (props) => {
        return (
            <MovementScreen
                {...props}
                user={user}
                getTranslation={getTranslation}
                formatDate={formatDate}
            />
        );
    };

    const DigestateComponentWrapper = (props) => {
        return (
            <HandlingDigestateScreen
                {...props}
                user={user}
                getTranslation={getTranslation}
                formatDate={formatDate}
            />
        );
    };

    const DataComponentWrapper = (props) => {
        return (
            <DataScreen
                {...props}
                getTranslation={getTranslation}
                user={user}
                formatDate={formatDate}
                language={language}
            />
        );
    };

    const ProfileComponentWrapper = (props) => {
        return (
            <ProfileScreenFarmer
                {...props}
                getTranslation={getTranslation}
                user={user}
                formatDate={formatDate}
            />
        );
    };

    return (

        <FarmerStack.Navigator
            screenOptions={({ route }) => ({
                tabBarIcon: ({ color, size }) => {
                    let iconName;
                    switch (route.name) {
                        case titles.first:
                            iconName = "home";
                            break;
                        case titles.second:
                            iconName = "grass";
                            break;
                        case titles.third:
                            iconName = "chart-bar";
                            break;
                        case titles.fourth:
                            iconName = "account";
                            break;
                        default:
                            iconName = "truck";
                            break;
                    }
                    return (
                        <MaterialCommunityIcons name={iconName} color={color} size={size} />
                    );
                },
                tabBarActiveTintColor: "green",
                tabBarInactiveTintColor: "gray",
            })}
        >

            <FarmerStack.Screen
                name={titles.first}
                component={MovementComponentWrapper}
                options={{
                    header: () => (
                        <Header
                            title={titles.first}
                            icon="home"
                            user={user}
                            getTranslation={getTranslation}
                            loginStatus={loginStatus}
                        />
                    ),
                }}
            />

            {user.hasDigestate && (
                <FarmerStack.Screen
                    name={titles.second}
                    component={DigestateComponentWrapper}
                    options={{
                        header: () => (
                            <Header
                                title={titles.second}
                                icon="grass"
                                user={user}
                                getTranslation={getTranslation}
                                loginStatus={loginStatus}
                            />
                        ),
                    }}
                />
            )}

            <FarmerStack.Screen
                name={titles.third}
                component={DataComponentWrapper}
                options={{
                    header: () => (
                        <Header
                            title={titles.third}
                            icon="chart-bar"
                            user={user}
                            getTranslation={getTranslation}
                            loginStatus={loginStatus}
                        />
                    ),
                }}
            />

            <FarmerStack.Screen
                name={titles.fourth}
                component={ProfileComponentWrapper}
                options={{
                    header: () => (
                        <Header
                            title={titles.fourth}
                            icon="account"
                            user={user}
                            getTranslation={getTranslation}
                            loginStatus={loginStatus}
                        />
                    ),
                }}
            />
        </FarmerStack.Navigator>
    )
}

const CarrierNavigator = ({ language, user, titles, loginStatus }) => {
    const [hasActiveRequest, setHasActiveRequest] = useState(false);

    const fetchActiveRequests = async () => {
        const activeRequests = await fetchActiveTransferGroup();
        setHasActiveRequest(activeRequests.data?.length > 0);
    };

    return (
        <CarrierStack.Navigator
            screenOptions={({ route }) => ({
                tabBarIcon: ({ color, size }) => {
                    let iconName;
                    switch (route.name) {
                        case titles.first:
                            iconName = "truck";
                            break;
                        case getTranslation("Richieste"):
                            iconName = "clipboard-list-outline";
                            break;
                        case titles.third:
                            iconName = "account";
                            break;
                        default:
                            iconName = "truck";
                            break;
                    }
                    return (
                        <MaterialCommunityIcons name={iconName} color={color} size={size} />
                    );
                },
                tabBarActiveTintColor: "green",
                tabBarInactiveTintColor: "gray",
                tabBarBadge:
                    route.name === getTranslation("Tratte Trasporti") && hasActiveRequest
                        ? "1"
                        : null,
            })}
        >
            <CarrierStack.Screen
                name={getTranslation("Richieste")}
                component={(props) => (
                    <RequestsScreen
                        {...props}
                        getTranslation={getTranslation}
                        user={user}
                        formatDate={formatDate}
                        fetchActiveRequests={fetchActiveRequests}
                    />
                )}
                options={{
                    header: () => (
                        <Header
                            title={titles.second}
                            icon="clipboard-list-outline"
                            user={user}
                            getTranslation={getTranslation}
                            loginStatus={loginStatus}
                        />
                    ),
                    unmountOnBlur: true,
                }}
            />

            <CarrierStack.Screen
                name={titles.first}
                component={(props) => (
                    <TrasportRoutesScreen
                        {...props}
                        getTranslation={getTranslation}
                        user={user}
                        formatDate={formatDate}
                        loginStatus={loginStatus}
                        fetchActiveRequests={fetchActiveRequests}
                    />
                )}
                options={{
                    header: () => (
                        <Header
                            title={titles.first}
                            icon="truck"
                            user={user}
                            getTranslation={getTranslation}
                            loginStatus={loginStatus}
                        />
                    ),
                    unmountOnBlur: true,
                }}
            />

            <CarrierStack.Screen
                name={titles.third}
                component={(props) => (
                    <ProfileScreenDriver
                        {...props}
                        language={language}
                        user={user}
                        getTranslation={getTranslation}
                        formatDate={formatDate}
                    />
                )}
                options={{
                    header: () => (
                        <Header
                            title={titles.third}
                            icon="account"
                            user={user}
                            getTranslation={getTranslation}
                            loginStatus={loginStatus}
                        />
                    ),
                    unmountOnBlur: true,
                }}
            />
        </CarrierStack.Navigator>
    );
};

const StackNavigator = ({
    language,
    user,
    titles,
    role,
    loginStatus = { loginStatus },
}) => {
    switch (role) {
        case "Farmer":
            return (
                <FarmerNavigator
                    language={language}
                    user={user}
                    titles={titles}
                    loginStatus={loginStatus}
                />
            );
        case "Driver":
            return (
                <CarrierNavigator
                    language={language}
                    user={user}
                    titles={titles}
                    loginStatus={loginStatus}
                />
            );
        case "SharedDepositManager":
            return (
                <SharedDepositManagerNavigator
                    language={language}
                    user={user}
                    titles={titles}
                    loginStatus={loginStatus}
                />
            );
        default:
            return (
                <FarmerNavigator
                    language={language}
                    user={user}
                    titles={titles}
                    loginStatus={loginStatus}
                />
            );
    }
};

const MainNavigator = ({ language, user, loginStatus }) => {
    // ensure role and titles are always valid strings
    const safeGetTranslation = (key) => {
        try {
            const t = getTranslation(key);
            return t || key;
        } catch (e) {
            return key;
        }
    };

    const getTitlesForRole = (role) => {
        switch (role) {
            case "Farmer":
                return {
                    first: safeGetTranslation("Movimenti"),
                    second: safeGetTranslation("Gärrestmanagement"),
                    third: safeGetTranslation("Dati"),
                    fourth: safeGetTranslation("Profilo"),
                };
            case "Driver":
                return {
                    first: safeGetTranslation("Tratte Trasporti"),
                    second: safeGetTranslation("Richieste"),
                    third: safeGetTranslation("Profilo"),
                };
            case "PlantTransferSupervisor":
                return {
                    first: safeGetTranslation("Piano operativo trasporti"),
                    second: safeGetTranslation("Accettazione Materiali"),
                    third: safeGetTranslation("Consuntivo trasporti"),
                    fourth: safeGetTranslation("Piano generale trasporti"),
                };
            case "SharedDepositManager":
                return {
                    first: safeGetTranslation("Movimenti"),
                    second: safeGetTranslation("Gärrestmanagement"),
                    third: safeGetTranslation("Dati"),
                    fourth: safeGetTranslation("Profilo"),
                };
            default:
                return {
                    first: safeGetTranslation("Tratte Trasporti"),
                    second: safeGetTranslation("Statistiche"),
                    third: safeGetTranslation("Profilo"),
                };
        }
    };

    const role = (user && user.landingView) ? user.landingView : "Farmer";
    const titles = getTitlesForRole(role);

    return (
        <StackNavigator
            language={language}
            user={user}
            titles={titles}
            role={role}
            loginStatus={loginStatus}
        />
    );
};

{
    /*END DECLARE STACK NAVIGATOR */
}

export default AppNavigator;
